"use strict";

exports.__esModule = true;
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = require("prop-types");

var _excluded = ["unique"];

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var propTypes = {
  unique: _propTypes.string
};

var Receipt = function Receipt(_ref) {
  var _ref$unique = _ref.unique,
      unique = _ref$unique === void 0 ? "" : _ref$unique,
      props = _objectWithoutPropertiesLoose(_ref, _excluded);

  return /*#__PURE__*/_react["default"].createElement("svg", _extends({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/_react["default"].createElement("defs", {
    fill: "inherit"
  }), /*#__PURE__*/_react["default"].createElement("g", {
    fill: "inherit",
    fillRule: "evenodd",
    id: "glyphs/shopping/receipt-receipt" + unique,
    stroke: "none",
    strokeWidth: 1
  }, /*#__PURE__*/_react["default"].createElement("use", {
    fill: "inherit",
    id: "combined-shape-receipt" + unique,
    xlinkHref: "#path-1-receipt" + unique
  }), /*#__PURE__*/_react["default"].createElement("g", {
    fill: "inherit",
    id: "colors/core/gunmetal-receipt" + unique
  }, /*#__PURE__*/_react["default"].createElement("path", {
    d: "M6,1 L8,3 L10,1 L12,3 L13.9995117,1 L15.9951172,3 L18,1 L18,23 L16,21 L14,23 L12,21 L10,23 L8,21 L6,23 L6,1 Z M8.5,7 C8.22385763,7 8,7.22385763 8,7.5 C8,7.77614237 8.22385763,8 8.5,8 L15.5,8 C15.7761424,8 16,7.77614237 16,7.5 C16,7.22385763 15.7761424,7 15.5,7 L8.5,7 Z M8.5,10 C8.22385763,10 8,10.2238576 8,10.5 C8,10.7761424 8.22385763,11 8.5,11 L15.5,11 C15.7761424,11 16,10.7761424 16,10.5 C16,10.2238576 15.7761424,10 15.5,10 L8.5,10 Z M8.5,13 C8.22385763,13 8,13.2238576 8,13.5 C8,13.7761424 8.22385763,14 8.5,14 L15.5,14 C15.7761424,14 16,13.7761424 16,13.5 C16,13.2238576 15.7761424,13 15.5,13 L8.5,13 Z M8.5,16 C8.22385763,16 8,16.2238576 8,16.5 C8,16.7761424 8.22385763,17 8.5,17 L15.5,17 C15.7761424,17 16,16.7761424 16,16.5 C16,16.2238576 15.7761424,16 15.5,16 L8.5,16 Z",
    fill: "inherit",
    id: "path-1-receipt" + unique
  }))));
};

Receipt.propTypes = propTypes;
var _default = Receipt;
exports["default"] = _default;